/*
 * Copyright Huesik (c) 2019.
 */


var statePositionList = [
  { name: '서울특별시',  lat: 37.566485, lng: 126.978347 },
  { name: '인천광역시',  lat: 37.3947280 , lng: 126.6752660 },
  { name: '경기도',  lat: 37.3892500 , lng: 127.4719210 },
  { name: '강원도',  lat: 37.7264630 , lng: 128.2760440 },
  { name: '충청북도',  lat: 36.8831320 , lng: 127.7024540 },
  { name: '세종특별자치시',  lat: 36.4800980 , lng: 127.2890350 },
  { name: '충청남도',  lat: 36.5504500 , lng: 126.7789500 },
  { name: '대전광역시',  lat: 36.3503820 , lng: 127.3847380 },
  { name: '경상북도',  lat: 36.4879500 , lng: 128.6747440 },
  { name: '전라북도',  lat: 35.7326390 , lng: 127.1423370 },
  { name: '대구광역시',  lat: 35.8672080 , lng: 128.6086080 },
  { name: '울산광역시',  lat: 35.5315100 , lng: 129.3644530 },
  { name: '경상남도',  lat: 35.4327590 , lng: 128.2469000 },
  { name: '부산광역시',  lat: 35.1718080 , lng: 129.0902060 },
  { name: '광주광역시',  lat: 35.1565270 , lng: 126.8527710 },
  { name: '전라남도',  lat: 34.9415470 , lng: 126.9883470 },
  { name: '제주도',  lat: 33.4079640 , lng: 126.5215950 },
]

export default statePositionList
